'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002etypes$0024$002dDirective$002dDescription$0024 from "./presto.types$-Directive-Description$.js";
import * as $j_presto$002etypes$0024$002dDirective$002dId$0024 from "./presto.types$-Directive-Id$.js";
import * as $j_presto$002etypes$0024$002dDirective$002dKind$0024 from "./presto.types$-Directive-Kind$.js";
import * as $j_presto$002etypes$0024$002dDirective$002dParams$0024 from "./presto.types$-Directive-Params$.js";
import * as $j_presto$002etypes$0024$002dDirective$002dPath$0024 from "./presto.types$-Directive-Path$.js";
import * as $j_presto$002etypes$0024$002dDirective$002dSelector$0024 from "./presto.types$-Directive-Selector$.js";
import * as $j_presto$002etypes$0024$002dRestricted$002dDomain$002dId$0024 from "./presto.types$-Restricted-Domain-Id$.js";
var $p;
/** @constructor */
function $c_Lpresto_Domains$$anon$1(outer) {
  this.aMV = null;
  this.aMT = null;
  this.aMU = false;
  this.aMR = null;
  this.aMS = false;
  this.aMW = false;
  this.aMX = false;
  if ((outer === null)) {
    throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_NullPointerException__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_NullPointerException());
  }
  this.aMV = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
}
export { $c_Lpresto_Domains$$anon$1 as $c_Lpresto_Domains$$anon$1 };
$p = $c_Lpresto_Domains$$anon$1.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_Domains$$anon$1;
/** @constructor */
function $h_Lpresto_Domains$$anon$1() {
}
export { $h_Lpresto_Domains$$anon$1 as $h_Lpresto_Domains$$anon$1 };
$h_Lpresto_Domains$$anon$1.prototype = $p;
$p.a1 = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this, a);
});
$p.ad = (function() {
  return this.aMV;
});
$p.t = (function() {
  if ((!this.aMU)) {
    this.aMT = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("domain", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("id", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("selector", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("path", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("kind", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("description", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("params", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$())))))));
    this.aMU = true;
  }
  return this.aMT;
});
$p.ae = (function() {
  if ((!this.aMS)) {
    this.aMR = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dRestricted$002dDomain$002dId$0024.$m_Lpresto_types$RestrictedDomainId$().GJ(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lio_circe_Encoder$$anon$24($j_presto$002etypes$0024$002dDirective$002dId$0024.$m_Lpresto_types$DirectiveId$().adv()), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dDirective$002dSelector$0024.$m_Lpresto_types$DirectiveSelector$().cHZ(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dDirective$002dPath$0024.$m_Lpresto_types$DirectivePath$().cHY(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dDirective$002dKind$0024.$m_Lpresto_types$DirectiveKind$().cHW(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dDirective$002dDescription$0024.$m_Lpresto_types$DirectiveDescription$().cHV(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lio_circe_Encoder$$anon$24($j_presto$002etypes$0024$002dDirective$002dParams$0024.$m_Lpresto_types$DirectiveParams$().cHX()), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$())))))));
    this.aMS = true;
  }
  return this.aMR;
});
$p.w = (function() {
  if ((!this.aMX)) {
    this.aMW = false;
    this.aMX = true;
  }
  return this.aMW;
});
$p.ac = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredEncoder__encodeProduct__O__Lio_circe_JsonObject(this, a);
});
var $d_Lpresto_Domains$$anon$1 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_Domains$$anon$1, "presto.Domains$$anon$1", ({
  Ho: 1,
  a: 1,
  k: 1,
  n: 1,
  o: 1,
  p: 1,
  d: 1
}));
export { $d_Lpresto_Domains$$anon$1 as $d_Lpresto_Domains$$anon$1 };
//# sourceMappingURL=presto.-Domains$$anon$1.js.map
